<div class="new-region-selector text-left text-small">
  <span class="iconfont iconditu_dingwei icon-style"></span>
  <div class="new-selected-region" [ngClass]="{'expanded': expand}" (click)="onMouseEnter()">
    <img class="regionFlag" [src]="'../../../assets/images/footer/' + selectedRegion.code + '.png' | absUrl"
      alt="{{selectedRegion.title}}">
    {{ selectedRegion.title }}
  </div>

  <div class="new-regions" [ngClass]="{'expanded': expand}"
    [ngStyle]="{'height':expand ? 10 + (36 * regions.length) + 'px' : '14px' }" (mouseleave)="onMouseLeave()">
    <div class="inner">
      <div class="new-items">
        <div class="new-item d-flex" *ngFor="let item of regions"
          [ngClass]="{'selected': item.title===selectedRegion.title}" (click)="selectRegion(item.title, item.code)">
          <img class="regionFlag" [src]="'../../../assets/images/footer/' + item.code + '.png' | absUrl" alt="{{item.title}}" loading="lazy">
          <span class="region-text name">{{ item.title }}</span>
          <span class="region-text">({{ item.code }})</span>
        </div>
      </div>
    </div>
  </div>
  <app-box-arrow *ngIf="expand" [colorChange]="true" [direction]="'bottom'"></app-box-arrow>

</div>